/// <reference types="googlemaps" />
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription, empty } from 'rxjs';
import { ContactService } from '../contact.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-contactme',
  templateUrl: './contactme.component.html',
  styleUrls: ['./contactme.component.css'],
})
export class ContactmeComponent implements OnInit, OnDestroy {
  constructor(private contact: ContactService, private titleService: Title) {}
  public subscription: Subscription;

  title = 'Contact - Rahil Hastu';

  contactMe = { name: '', subject: '', email: '', comment: '' };
  formTitle = {
    name: 'Required',
    email: 'Enter valid Email Address',
    subject: 'Required',
    comment: 'Min 3 Characters',
  };
  contactForm: FormGroup;

  ngOnInit(): void {
    this.titleService.setTitle(this.title);

    let body = document.querySelector('body');
    body.classList.remove('container');

    let title = <HTMLElement[]>(<any>document.querySelectorAll('.title span'));
    setTimeout(() => {
      let delay = 0;
      title.forEach((spanEle) => {
        spanEle.style.animation = `comeout 1s ease ${delay}s forwards`;
        delay += 0.05;
      });
    }, 1000);

    var markerPos = { lat: 33.420764, lng: -111.932674 };
    // 12.9141;
    var uluru = { lat: 33.414279, lng: -112.024991 };
    var map = new google.maps.Map(
      document.getElementById('map') as HTMLElement,
      {
        zoom: 5,
        minZoom: 3,
        maxZoom: 15,
        // draggable: false ,
        // scrollwheel: false,
        // panControl: false,
        center: uluru,
        mapTypeControl: false,
        // disableDefaultUI: true,
        zoomControl: false,
        styles: [
          { elementType: 'geometry', stylers: [{ color: '#a34d45' }] },
          {
            elementType: 'labels.text.stroke',
            stylers: [{ color: '#000000' }],
          },
          {
            elementType: 'labels.text.fill',
            stylers: [{ color: '#ffffff' }],
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [{ color: '#282626' }],
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{ color: '#000000' }],
          },
        ],
      }
    );
    const icon = './assets/images/map_marker.png';
    var marker = new google.maps.Marker({
      position: markerPos,
      map: map,
      title: 'Arizona, USA',
      icon: icon,
    });

    title.forEach((spanTag) => {
      spanTag.addEventListener('mouseover', () => {
        spanTag.style.opacity = '1';
        spanTag.style.animation = '';
        spanTag.classList.toggle('bounce');
      });
    });

    this.contactForm = new FormGroup({
      name: new FormControl(this.contactMe.name, [Validators.required]),
      email: new FormControl(this.contactMe.email, [
        Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
      ]),
      subject: new FormControl(this.contactMe.subject, [Validators.required]),
      comments: new FormControl(this.contactMe.comment, [
        Validators.minLength(3),
      ]),
    });
  }

  get name() {
    return this.contactForm.get('name');
  }
  get email() {
    return this.contactForm.get('email');
  }
  get subject() {
    return this.contactForm.get('subject');
  }
  get comment() {
    return this.contactForm.get('comments');
  }
  onSubmit() {
    this.contactMe.name = this.contactForm.value.name;
    this.contactMe.subject = this.contactForm.value.subject;
    this.contactMe.email = this.contactForm.value.email;
    this.contactMe.comment = this.contactForm.value.comments;
    // console.log(this.contactMe.email + ' Hello');

    this.subscription = this.contact.sendEmail(this.contactMe).subscribe(
      (data) => {
        let msg = data['message'];
        // alert(msg);
        info.classList.remove('wait');
        info.classList.add('success');
        setTimeout(function () {
          info.classList.remove('success');
        }, 3000);
      },
      (error) => {
        info.classList.add('error');
        setTimeout(function () {
          info.classList.remove('error');
        }, 3000);
      }
    );
    this.contactForm.reset();

    let info = <HTMLElement>document.querySelector('.info');
    info.classList.add('wait');
  }

  ngOnDestroy() {
    let body = document.querySelector('body');
    body.classList.add('container');
  }
}
